// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, MessageCircle, Phone, MapPin, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white pt-16 pb-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 lg:gap-12">
          {/* بخش اول: لوگو و توضیح کوتاه */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center text-black font-bold text-2xl shadow-lg">
                خ
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-gold">خرمی‌گلد</h3>
            </Link>

            <p className="text-gray-300 leading-relaxed text-lg">
              گالری طلا و جواهری خرمی – از سال ۱۳۵۰ با افتخار در خدمت شما هستیم.
              اصالت، کیفیت و اعتماد اولویت ماست.
            </p>

            <div className="flex items-center gap-3 text-gray-400">
              <MapPin size={18} />
              <span>اصفهان، چهارباغ عباسی، بازار هنر</span>
            </div>
          </div>

          {/* بخش دوم: لینک‌های سریع */}
          <div>
            <h4 className="text-xl font-bold text-gold mb-6">لینک‌های سریع</h4>
            <ul className="space-y-4 text-gray-300">
              <li>
                <Link to="/" className="hover:text-gold transition flex items-center gap-2">
                  خانه
                </Link>
              </li>
              <li>
                <Link to="/products" className="hover:text-gold transition flex items-center gap-2">
                  محصولات
                </Link>
              </li>
              <li>
                <Link to="/affordable" className="hover:text-gold transition flex items-center gap-2">
                  محصولات اقتصادی
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-gold transition flex items-center gap-2">
                  درباره ما
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-gold transition flex items-center gap-2">
                  تماس با ما
                </Link>
              </li>
            </ul>
          </div>

          {/* بخش سوم: اطلاعات تماس */}
          <div>
            <h4 className="text-xl font-bold text-gold mb-6">اطلاعات تماس</h4>
            <ul className="space-y-5 text-gray-300">
              <li className="flex items-center gap-3">
                <Phone size={20} className="text-gold" />
                <span>۰۳۱-۳۲۲۲۲۰۴۲</span>
              </li>
              <li className="flex items-center gap-3">
                <MessageCircle size={20} className="text-gold" />
                <a href="https://wa.me/989215316012" className="hover:text-gold transition">
                  ۰۹۲۱-۵۳۱۶۰۱۲ (واتساپ)
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={20} className="text-gold" />
                <a href="mailto:info@khorramigold.com" className="hover:text-gold transition">
                  info@khorramigold.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-gold mt-1" />
                <span>
                  اصفهان، خیابان چهارباغ عباسی،<br />
                  بازار هنر، گالری طلا و جواهر خرمی
                </span>
              </li>
            </ul>
          </div>

          {/* بخش چهارم: شبکه‌های اجتماعی */}
          <div>
            <h4 className="text-xl font-bold text-gold mb-6">ما را دنبال کنید</h4>
            <div className="flex gap-4">
              <a
                href="https://instagram.com/Khorrami.gallery"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center hover:bg-gold hover:text-black transition text-gold"
              >
                <Instagram size={24} />
              </a>

              <a
                href="https://wa.me/989215316012"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-green-600/20 rounded-full flex items-center justify-center hover:bg-green-600 transition text-green-600 hover:text-white"
              >
                <MessageCircle size={24} />
              </a>

              <a
                href="tel:03132222042"
                className="w-12 h-12 bg-blue-600/20 rounded-full flex items-center justify-center hover:bg-blue-600 transition text-blue-600 hover:text-white"
              >
                <Phone size={24} />
              </a>
            </div>

            <p className="mt-8 text-gray-500 text-sm">
              پاسخگویی در واتساپ و اینستاگرام: ۹ صبح تا ۱۰ شب
            </p>
          </div>
        </div>

        {/* کپی‌رایت */}
        <div className="border-t border-gray-800 mt-16 pt-8 text-center text-gray-500 text-sm">
          <p>© {new Date().getFullYear()} گالری طلا و جواهری خرمی – تمامی حقوق محفوظ است</p>
          <p className="mt-2">
            طراحی و توسعه: <span className="text-gold">تیم خرمی‌گلد</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;